import React from "react";

interface AppLoaderProps {
  size?: "sm" | "md" | "lg";
  overlay?: boolean;
  message?: string;
}

const AppLoader: React.FC<AppLoaderProps> = ({ size = "md", overlay = true, message = "Loading..." }) => {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
  };

  const spinnerSize = sizeClasses[size];

  if (overlay) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-80 backdrop-blur-sm">
        <div className="flex flex-col items-center space-y-4">
          <div className={`${spinnerSize} border-4 border-gray-200 border-t-dynamicColor-primary rounded-full animate-spin`}></div>
          {message && <p className="text-sm text-gray-600 font-medium">{message}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4">
      <div className="flex flex-col items-center space-y-4">
        <div className={`${spinnerSize} border-4 border-gray-200 border-t-dynamicColor-primary rounded-full animate-spin`}></div>
        {message && <p className="text-sm text-gray-600 font-medium">{message}</p>}
      </div>
    </div>
  );
};

export default AppLoader;
